function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 36h-5c-0.825 0-1.5-0.675-1.5-1.5v-5c0-0.825 0.675-1.5 1.5-1.5h5c0.825 0 1.5 0.675 1.5 1.5v5c0 0.825-0.675 1.5-1.5 1.5zm13.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5zm12 0v-5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5zm-12 12v-5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5zm-12 0v-5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5zm24 0v-5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5zm12-32.5v44c0 3.3125-2.6875 6-6 6h-44c-3.3125 0-6-2.6875-6-6v-44c0-3.3125 2.6875-6 6-6h6v-6.5c0-0.825 0.675-1.5 1.5-1.5h5c0.825 0 1.5 0.675 1.5 1.5v6.5h16v-6.5c0-0.825 0.675-1.5 1.5-1.5h5c0.825 0 1.5 0.675 1.5 1.5v6.5h6c3.3125 0 6 2.6875 6 6zm-6 43.25v-37.25h-44v37.25c0 0.4125 0.3375 0.75 0.75 0.75h42.5c0.4125 0 0.75-0.3375 0.75-0.75z",
    fill: "currentColor",
    style: {
      strokeWidth: 0.125
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4d19bcb2.svg";
export { ForwardRef as ReactComponent };